import React from "react";
import { Alert, Box, Card, Container, Stack, Text, Title } from "@mantine/core";
import { InviteByEmailCard } from "./InviteProjectMember";
import { useAppSelector } from "../app/hooks";
import { ProjectInvitesGrid } from "./ProjectInvitesList";
import { ProjectMembersGrid } from "./ProjectMembersGrid";
import { selectIsSystemAdmin } from "../userSelectors";

export const ProjectMembers: React.FC = () => {
  const isSystemAdmin = useAppSelector(selectIsSystemAdmin);

  return (
    <Box style={{ height: "100%", overflowY: "auto" }}>
      <Container size="md" py="lg">
        <Stack gap="md">
          <Title order={4}>Eksterne prosjektmedlemmer</Title>

          {!isSystemAdmin ? (
            <Alert color="yellow" title="Begrenset tilgang">
              Kun systemadministratorer kan invitere eksterne brukere til prosjekter.
            </Alert>
          ) : (
            <>
              <Text size="sm" c="dimmed">
                Kun systemadministratorer kan invitere eksterne brukere til prosjekter.
              </Text>

              <InviteByEmailCard />
            </>
          )}

          <ProjectInvitesGrid />

          <ProjectMembersGrid />
        </Stack>
      </Container>
    </Box>
  );
};
